// src/core/storage.ts
import type { GameRecord } from '../types';

export const STORAGE_KEY = 'barve.v1';
const PROBE_KEY = 'barve.probe';

function logWarn(tag: string, msg: string, err?: unknown): void {
  // eslint-disable-next-line no-console
  console.warn(tag, msg, err ?? '');
}

export function load(): GameRecord | null {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (raw === null) return null;
    return JSON.parse(raw) as GameRecord;
  } catch (err) {
    logWarn('[storage]', 'load failed (corrupt or unavailable)', err);
    return null;
  }
}

export function save(rec: GameRecord): void {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(rec));
  } catch (err) {
    if (err instanceof Error && err.name === 'QuotaExceededError') {
      logWarn('[storage]', 'quota exceeded; stats not persisted');
    } else {
      logWarn('[storage]', 'save failed', err);
    }
  }
}

export function available(): boolean {
  try {
    localStorage.setItem(PROBE_KEY, '1');
    localStorage.removeItem(PROBE_KEY);
    return true;
  } catch {
    return false;
  }
}
